// Ring Protect (MX) — Plans page (templates/page.plans-protect-test.liquid)
// Unified script for the whole page — previously split between an inline
// <script> block and plans-protect-accordion.js, now consolidated here.

// ---------- Feature accordion (under the 50/50 recognition section) ----------
(function () {
  var accordion = document.querySelector('[data-rp-accordion]');
  if (!accordion) return;
  var items = accordion.querySelectorAll('[data-rp-accordion-item]');

  function setOpen(item, open) {
    var trigger = item.querySelector('[data-rp-accordion-trigger]');
    var panel = item.querySelector('[data-rp-accordion-panel]');
    if (!trigger || !panel) return;
    item.classList.toggle('is-open', open);
    trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    panel.style.maxHeight = open ? panel.scrollHeight + 'px' : null;
  }

  items.forEach(function (item) {
    var trigger = item.querySelector('[data-rp-accordion-trigger]');
    if (!trigger) return;

    if (item.classList.contains('is-open')) {
      setOpen(item, true);
    }

    trigger.addEventListener('click', function () {
      var willOpen = !item.classList.contains('is-open');
      items.forEach(function (other) { setOpen(other, other === item && willOpen); });
    });
  });

  window.addEventListener('resize', function () {
    items.forEach(function (item) {
      if (item.classList.contains('is-open')) setOpen(item, true);
    });
  });
})();

// ---------- Feature-cards mobile slider ----------
// Scoped entirely to <= 768px — desktop's 3-col grid is left alone.
(function () {
  var mobileQuery = window.matchMedia('(max-width: 768px)');
  var track = document.querySelector('[data-rp-cards-track]');
  var dotsWrap = document.querySelector('[data-rp-cards-dots]');
  if (!track || !dotsWrap) return;

  var cards = Array.prototype.slice.call(track.querySelectorAll('.rp-feature-card'));
  var dots = Array.prototype.slice.call(dotsWrap.querySelectorAll('[data-rp-cards-dot]'));
  if (!cards.length || cards.length !== dots.length) return;

  var observer = null;

  function setActiveDot(index) {
    dots.forEach(function (dot, i) {
      dot.classList.toggle('is-active', i === index);
    });
  }

  function startObserving() {
    if (observer) return;
    observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && entry.intersectionRatio >= 0.6) {
            setActiveDot(cards.indexOf(entry.target));
          }
        });
      },
      { root: track, threshold: [0.6] }
    );
    cards.forEach(function (card) { observer.observe(card); });
  }

  function stopObserving() {
    if (!observer) return;
    observer.disconnect();
    observer = null;
  }

  dots.forEach(function (dot, i) {
    dot.addEventListener('click', function () {
      cards[i].scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      setActiveDot(i);
    });
  });

  function syncToViewport(query) {
    if (query.matches) {
      setActiveDot(0);
      startObserving();
    } else {
      stopObserving();
    }
  }

  syncToViewport(mobileQuery);
  if (mobileQuery.addEventListener) {
    mobileQuery.addEventListener('change', syncToViewport);
  } else if (mobileQuery.addListener) {
    mobileQuery.addListener(syncToViewport);
  }
})();
